<template>
  <div>
    <el-row>
      <zk-table ref="table"
                stripe
                border
                :data="tableData"
                :columns="columnData"
                :height="350"></zk-table>
    </el-row>
    <el-row>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: left;">
          <el-pagination @size-change="changePageSize"
                         @current-change="changePage"
                         :current-page="curPage"
                         :page-size="pageSize"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"></el-pagination>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import * as dashboardApi from '@/services/enterpriseDashboardApi.js'
export default {
  data () {
    return {
      // pager: {
      // curPage: 1,
      // pageSize: 10
      // },
      total: 0,
      tableData: [],
      columnData: [
        {
          label: this.$t('device.sn'),
          prop: 'devSn'
        },
        {
          label: this.$t('device.name'),
          prop: 'devName'
        },
        {
          label: this.$t('device.alias'),
          prop: 'devAlias'
        }
      ]
    }
  },
  props: {
    dataType: {
      type: String,
      default: ''
    },
    curPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },

  mounted () {
    // this.pager = {
    //   curPage: 1,
    //   pageSize: 10
    // }
    this.tableData = []
    this.commQuery()
  },
  watch: {
    dataType () {
      this.tableData = []
      this.commQuery()
    }
  },
  methods: {
    changePage (current) {
      this.curPage = current
      this.commQuery()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.commQuery()
    },
    commQuery () {
      let params = {
        state: this.dataType === 'online' ? 1 : 0
      }

      dashboardApi.devStateTotalDetails({
        params: params,
        pager: {
          total: this.total,
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      }).then((data) => {
        if (data.code === '00000000') {
          this.tableData = data.payload.results
          this.total =
            data.payload.results.totalRecords || data.payload.totalRecords
          this.curPage =
            data.payload.results.curPage || data.payload.curPage
          this.total =
            data.payload.results.totalRecords || data.payload.totalRecords
          this.pageSize =
            data.payload.results.pageSize || data.payload.pageSize
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/deviceDetailsList.vue